import type { InsideTimelyCategory as ApiInsideTimelyCategory } from 'api/changelog/changelog.api.types';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { Notification } from 'types/notification';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/notifications');

export const fetchedNotifications = actionCreator<{
  notifications: Array<Notification>;
}>('FETCHED_NOTIFICATIONS');
export const fetchedSingleNotification = actionCreator<Notification>('FETCHED_SINGLE_NOTIFICATION');
export const markNotificationAsRead = actionCreator<MarkedAsReadPayload>('MARK_AS_READ');
export const markNotificationAsSeen = actionCreator<MarkedAsSeenPayload>('MARK_AS_SEEN');
export const markNotificationAsUnseen = actionCreator<MarkedAsSeenPayload>('MARK_AS_UNSEEN');
export const setTabState = actionCreator<TabStrings>('SET_TAB_STATE');

export enum TabStates {
  NOTIFICATIONS = 'NOTIFICATIONS',
  WHATS_NEW = 'WHATS_NEW',
  ALL = 'ALL',
}

export type TabStrings = keyof typeof TabStates;
export type InsideTimelyCategory = ApiInsideTimelyCategory;

export interface State {
  xhrStatus: XhrStatus;
  notifications: Array<Notification>;
  activeTab: TabStrings;
}
export interface MarkedAsReadPayload {
  id: number | string;
}
export interface MarkedAsSeenPayload {
  ids: Array<number>;
}

export enum NotificationActions {
  request = 'request',
  create = 'create',
  archival = 'archival',
  warning = 'warning',
  productUpdate = 'productUpdate',
  productChangelog = 'productChangelog',
}

export enum NotificationCategories {
  project = 'project',
  budget = 'budget',
  client = 'client',
  hour = 'hour',
  productUpdate = 'productUpdate',
  productChangelog = 'productChangelog',
  task = 'task',
}

export enum NotificationColors {
  default = 'white',
  action = '#59bce5',
  archived = '#a8b9bd',
  warning = '#ff5a83',
  anomaly = '#FF7B00',
  productUpdate = 'rgb(71, 177, 124)',
  productChangelog = productUpdate,
}

export const { wrapFetching, wrapSaving, withXhrStatusReducer } =
  createXhrStatusModule('notifications');
